var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconListChecks = function SvgIconListChecks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.303 5.235a1 1 0 1 0-1.356-1.47L5.373 6.139l-.944-.873a1 1 0 0 0-1.358 1.468l1.622 1.5a1 1 0 0 0 1.357.001zM12.75 5a1 1 0 1 0 0 2h7.5a1 1 0 1 0 0-2zM12.75 11a1 1 0 1 0 0 2h7.5a1 1 0 1 0 0-2zM11.75 18a1 1 0 0 1 1-1h7.5a1 1 0 1 1 0 2h-7.5a1 1 0 0 1-1-1M9.36 9.822a1 1 0 0 1-.057 1.413l-3.253 3a1 1 0 0 1-1.357 0l-1.622-1.5a1 1 0 0 1 1.358-1.47l.944.874 2.574-2.374a1 1 0 0 1 1.413.057M9.303 17.235a1 1 0 1 0-1.356-1.47l-2.574 2.374-.944-.873a1 1 0 0 0-1.358 1.468l1.622 1.5a1 1 0 0 0 1.357.001z"
  }))));
};
export default SvgIconListChecks;